import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Checkbox, Divider, Modal, Select, Typography } from 'antd'
import { useState } from 'react'
import { CancelTaskBooking, CheckCancelBookingDto, RefundPolicy } from '../../../../definition'
import { caculateRefund } from './cancel-booking'
import { toast } from 'react-toastify'
import { asyncConfirmRefund } from '../../../../services/booking.service'

interface ConfirmCancalBookingProps {
  trigger: React.ReactNode
  tasks: CancelTaskBooking[]
  refundPolicy: RefundPolicy
  bookingId: string
  onSave?: () => void
  cancelBookingDetail: CheckCancelBookingDto
}

export const ConfirmCancalBooking = ({
  trigger,
  tasks,
  refundPolicy,
  bookingId,
  onSave,
  cancelBookingDetail
}: ConfirmCancalBookingProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isConfirm, setIsConfirm] = useState(false)
  const [reason, setReason] = useState('')

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const handleConfirmRefund = async () => {
    try {
      await asyncConfirmRefund(
        bookingId,
        tasks.map((task) => task.taskId),
        reason
      )
      onSave?.()
      toast.success('Success cancel booking')
    } catch (error: any) {
      const { response } = error
      let msg = response.data.error.message
      toast.error(<>{msg}</>)
    } finally {
      setIsModalOpen(false)
    }
  }

  return (
    <>
      <div style={{ width: '100%' }} onClick={() => setIsModalOpen(true)}>
        {trigger}
      </div>
      <Modal
        width={618}
        closable={false}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        className={`modal-base`}
      >
        <Typography.Title level={4} className='modal-title'>
          Cancel Booking - Part 2
        </Typography.Title>
        <div className='cancel-booking-content'>
          <div className='cancel-booking-col span-full'>
            <div className='cancel-warning'>
              <ExclamationCircleOutlined style={{ color: 'red', marginTop: 6 }} />
              <div>
                <label>Final Confirmation Required. </label>
                <div>This action cannot be undone. Your selected sessions will be cancelled immediately.</div>
              </div>
            </div>
            <div className='reason-select'>
              <label>Reason for cancellation</label>
              <Select
                className='reason-select'
                placeholder='Please select a reason'
                options={(refundPolicy.reasonForCancellation.admin || []).map((policy) => {
                  return {
                    label: policy,
                    value: policy
                  }
                })}
                onChange={(value) => setReason(value)}
              />
            </div>
            <div className='cancel-caculation'>
              <label>Refund Calculation</label>
              {tasks.map((task, taskIndex) => {
                return (
                  <div className='cancel-caculation-item'>
                    <div>
                      Session {task.index + 1} : {task.refundFee ? '(50% penalty)' : '(Free cancellation)'}
                    </div>
                    <div>${parseFloat(task.refundAmount.toFixed(3))}</div>
                  </div>
                )
              })}

              <Divider style={{ marginTop: 0, marginBottom: 0 }} />
              <div className='cancel-caculation-item'>
                <label>Subtotal Refund:</label>
                <label>${parseFloat(caculateRefund(tasks || []).refundSubTotal.toFixed(3))}</label>
              </div>
              <Divider style={{ marginTop: 0, marginBottom: 0 }} />
              <div className='cancel-caculation-item'>
                <label>Final Refund Amount:</label>
                <label>${parseFloat(caculateRefund(tasks || []).finalRefund.toFixed(3))}</label>
              </div>
            </div>
            <div className='cancel-caculation' style={{ paddingBottom: 8 }}>
              <div className='cancel-caculation-item'>
                <div>Refund Destination:</div>
                <div>{cancelBookingDetail.refundDestination}</div>
              </div>
            </div>
            <div className='confirm-check'>
              <Checkbox
                checked={isConfirm}
                onChange={(e) => {
                  setIsConfirm(e.target.checked)
                }}
              />
              <div>
                I confirm I am cancelling on behalf of the client, accord to the cancellation terms and conditions as
                outlined in my service agreement, including all applicable fees and penalties based on session timing
                and completion status.
              </div>
            </div>
          </div>
          <div className='action-button'>
            <Button className='secondary' style={{ width: '100%', height: 50, fontWeight: 600 }} onClick={handleCancel}>
              Back
            </Button>
          </div>
          <div className='action-button'>
            <Button
              onClick={handleConfirmRefund}
              onDoubleClick={handleConfirmRefund}
              className='danger'
              disabled={!isConfirm || !reason}
              style={{ width: '100%', height: 50, fontWeight: 600 }}
            >
              Confirm Cancellation
              <br />
              (${caculateRefund(tasks || []).finalRefund.toFixed(2)} refund)
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}
